<template>
  <div class="Assessment">
    <HeaderTop/>
    <div class="w">
      <div class="assessment-box">
        <h3>在线评价</h3>
        <div class="assessment-container">
          <div class="container">
            <el-form ref="form" :model="form" :rules="rules">
              <div class="container-s">
                <el-form-item label="车辆品牌" prop="carBrand">
                  <el-input v-model="form.carBrand" placeholder="请输入车辆品牌"></el-input>
                </el-form-item>
                <el-form-item label="车辆型号" prop="carModel">
                  <el-input v-model="form.carModel" placeholder="请输入车辆型号"></el-input>
                </el-form-item>
                <el-form-item label="上牌日期" prop="licensDate">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="form.licensDate"
                    style="width: 100%;"
                    type="date"
                    placeholder="请选择上牌日期">
                  </el-date-picker>
                </el-form-item>
                <!-- <el-form-item label="上牌月份" prop="licensMonth">
                  <el-date-picker
                    v-model="form.licensMonth"
                    value-format="M"
                    style="width: 100%;"
                    type="month"
                    placeholder="請選擇上牌月份">
                  </el-date-picker>
                </el-form-item> -->
                <el-form-item label="上牌地点" prop="licensLocation">
                  <el-input v-model="form.licensLocation" placeholder="请输入上牌地点"></el-input>
                </el-form-item>
                <el-form-item label="行驶公里" prop="mileage">
                  <el-input v-model="form.mileage" placeholder="请输入行驶公里" ></el-input>
                </el-form-item>
              </div>
              <em></em>
              <div class="container-x">
                <el-form-item label="您的姓名" prop="cusName">
                  <el-input v-model="form.cusName" placeholder="请输入您的姓名" ></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phoneNo">
                  <el-input v-model="form.phoneNo" placeholder="请输入手机号码" ></el-input>
                </el-form-item>
              </div>
              <el-form-item>
                <el-button type="primary" @click="onSubmit($event)">在线评价</el-button>
              </el-form-item>
            </el-form>

            <!-- <p>*车辆品牌：<input type="text"></p>
            <p>*车辆型号：<input type="text"></p>
            <p>*上牌日期：<input type="text"></p>
            <p>*上牌月份：<input type="text"></p>
            <p>*上牌地点：<input type="text"></p>
            <p>*行驶公里：<input type="text"></p>
            <em></em>
            <p>*您的姓名：<input type="text"></p>
            <p>*手机号码：<input type="text"></p>
            
            <input type="button" value="免费评估"/> -->
          </div>
        </div>
      </div>
      <FooterAbout/>
    </div>
    <Copy/>
    <el-dialog
      title="温馨提示"
      :visible.sync="dialogAlert"
      width="30%"
      center>
      <span>感谢您的信任，本次评价结果将在半个小时内给您进行回复，谢谢！</span>
      <div slot="footer" class="dialog-footer">  
        <el-button type="primary" @click="changeAlert">确 定</el-button>
        <p>营业时间 9:00-18:00</p>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { reqAddCarAssess } from '../api'
import HeaderTop from '../components/HeaderTop.vue'
import FooterAbout from '../components/FooterAbout.vue'
import Cookies from 'js-cookie'
import Copy from '../components/Copy.vue'

export default {
  name: 'Assessment',
  data () {
    return {
      dialogAlert: false,
      form: {
        carBrand: '',
        carModel: '',
        licensDate: '',
        licensMonth: '',
        licensLocation: '',
        mileage: '',
        cusName: '',
        phoneNo: '',
        position: Cookies.get('position') || 2
      },
      rules:{
        carBrand: [{ required: true, message: '请输入车辆品牌', trigger: 'blur' }], 
        carModel: [{ required: true, message: '请输入车辆型号', trigger: 'blur' }], 
        licensDate: [{ required: true, message: '请选择上牌日期', trigger: 'blur' }], 
        // licensMonth: [{ required: true, message: '请选择上牌月份', trigger: 'blur' }], 
        licensLocation: [{ required: true, message: '请输入上牌地点', trigger: 'blur' }],  
        mileage: [{ required: true, message: '请输入行驶公里', trigger: 'blur' }],  
        cusName: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],  
        phoneNo: [{ required: true, message: '请输入手机号码', trigger: 'blur' }], 
      }
    }
  },
  methods: {
    changeAlert() {
      this.dialogAlert = false
      this.$message({
        message: "提交成功！",
        customClass: 'mode',
        type: 'success'
      })
    },
    onSubmit(event) {
      event.preventDefault()
      let formData = this.form
      console.log('formData', formData)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          reqAddCarAssess(formData).then( res => {
            if (res.status) {
              console.log('提交成功')
              this.dialogAlert = true
              console.log('reqAddCarAssess',formData)
              // this.$router.back(-1)
            } else {
              this.$message({
                message: "提交失败，请填写对应的内容！",
                customClass: 'mode',
                type: 'error'
              })
              return false
            }
            this.$nextTick(() => {
              this.$refs.form.resetFields()
              this.form.carBrand = ''
              this.form.carModel = ''
              this.form.licensDate = ''
              this.form.licensMonth = ''
              this.form.licensLocation = ''
              this.form.mileage = ''
              this.form.cusName = ''
              this.form.phoneNo = ''
            })
          })
        } else {  
          this.$message({
            message: "提交失败，请填写对应的内容！",
            customClass: 'mode',
            // duration: 300000,
            type: 'error'
          })
        }
      })
    }
  },
  components: {
    HeaderTop,
    FooterAbout,
    Copy
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .Assessment >>> .el-form 
    .el-form-item 
      margin-bottom 20px
      .el-form-item__label
        font-size 18px
        color #333
        height 34px
        line-height 40px
      .el-form-item__content
        margin-top 30px
        button
          width 200px
          height 40px
          font-size 17px
          &.el-button--primary
            background-color #040404
            border-color #000
    .el-form-item__content .el-input
      input
        font-size 16px
        height 40px
        line-height 40px

  .Assessment >>> .el-dialog__wrapper
    .el-dialog
      width 36% !important
      margin-top 25% !important
      .el-dialog__header
        border-bottom 1px solid #ccc
        .el-dialog__title
          font-size 20px
        .el-dialog__headerbtn
          font-size 16px
          &:hover .el-dialog__close
            color #e7731d
      .el-dialog__body
        font-size 16px
        line-height 20px
        padding 0.333333rem 0.433333rem 0.7rem
      .el-dialog__footer
        .el-button 
          font-size 16px
          padding 0.162rem 0.766667rem
        .el-button--primary
          background #e7731d
          border-color #e7731d
          &:hover
            background #e1823c
            border-color #e1823c
        p
          color red
          font-size 14px
          font-weight 600
          margin-top 8px
  
  .Assessment
    width 100%
    .assessment-box
      h3
        font-size 24px
        text-indent 32px
        padding 30px 0 0 0
        &:after
          content ''
          display block
          margin-top 14px
          border-bottom 2px solid #ccc
      .assessment-container
        font-size 16px
        padding 30px 0
        overflow hidden
        .container
          width 50%
          background rgba(217,217,217,0.5)
          margin 0 auto
          padding 20px 0
          text-align center
          border-radius 1px
          box-shadow 2px 2px 3px #ccc
          position relative
          .container-s,
          .container-x
            padding 0 40px
          // &:after,
          // &:before
          //   width 200px
          //   height 200px
          //   content ''
          //   display block
          //   background #fffde
          //   position absolute
          //   transform rotate(45deg)
          // &:after
          //   bottom -126px
          //   left -126px
          // &:before
          //   top -126px
          //   right -126px
          p
            padding 10px
            text-align center
          input
            height 30px
            margin-left 10px
          input[type="text"]
            padding-left 10px
            border 1px solid #bfbfbf
            border-radius 2px
          input[type="button"]
            height 44px
            color #222
            background #a6a6a6
            margin-top 20px
            padding 0 60px
            cursor pointer
          em
            display block
            width 100%
            height 1px
            margin 20px auto
            // background #9d9d9d



  // 表单
  @media screen and (min-width: 0) and (max-width: 1199px) 
    .Assessment .assessment-box h3
      width 92% !important
      margin 0 auto !important
  @media screen and (min-width: 500px) and (max-width: 800px) 
    .Assessment .assessment-box .assessment-container .container
      width 80% !important
  @media screen and (min-width: 360px) and (max-width: 499px) 
    .Assessment .assessment-box .assessment-container .container
      width 96% !important
  @media screen and (min-width: 0px) and (max-width: 360px) 
    .Assessment .assessment-box .assessment-container .container
      width 100% !important
      p
        paadding 10px 0
      
</style>



// WEBPACK FOOTER //
// src/pages/Assessment.vue